import React, { Component } from 'react'

import styled from 'styled-components'

import Icon, { IconNames } from 'components/icons'
import theme from 'components/theme'
import { common } from 'constants/e2eClasses'

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 8px 0 0;
`

const Message = styled.div.attrs(props => ({
  className: `${common.inputError || ''}${props.e2eClass || ''}`
}))`
  display: flex;
  flex: 1;
  color: ${({ color }) => color};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
`

const IconContainer = styled.div.attrs(props => ({
  className: `${common.inputIconError || ''}${props.e2eClass || ''}`
}))`
  margin-right: 10px;

  svg {
    vertical-align: bottom;

    path {
      fill: ${({ color }) => color};
    }
  }
`
class HelpText extends Component {
  render() {
    const { color, iconName, message, e2eClass, id } = this.props

    if (!message) return null

    return (
      <Wrapper>
        <IconContainer e2eClass={e2eClass} color={color}>
          <Icon name={iconName} size={20} />
        </IconContainer>
        <Message e2eClass={e2eClass} color={color} id={id}>
          {message}
        </Message>
      </Wrapper>
    )
  }
}

export class SuccessHelpText extends HelpText {
  static defaultProps = {
    color: theme.colors.green,
    iconName: IconNames.Checkmark
  }
}

export class ErrorHelpText extends HelpText {
  static defaultProps = {
    color: theme.colors.red,
    iconName: IconNames.Alert
  }
}

export class InfoHelpText extends HelpText {
  static defaultProps = {
    color: theme.colors.doveGray,
    iconName: IconNames.Info
  }
}
